__turbopack_context__.v({
  "cameraBoundsRow": "object-light-props-module__i6SK7W__cameraBoundsRow",
  "cameraBoundsRowSmall": "object-light-props-module__i6SK7W__cameraBoundsRowSmall",
  "cameraSettingsRow": "object-light-props-module__i6SK7W__cameraSettingsRow",
  "castShadowContainer": "object-light-props-module__i6SK7W__castShadowContainer",
  "colorPickerContainer": "object-light-props-module__i6SK7W__colorPickerContainer",
  "container": "object-light-props-module__i6SK7W__container",
  "inputContainer": "object-light-props-module__i6SK7W__inputContainer",
  "inputGroup": "object-light-props-module__i6SK7W__inputGroup",
  "inputLabel": "object-light-props-module__i6SK7W__inputLabel",
  "inputNumber": "object-light-props-module__i6SK7W__inputNumber",
  "inputNumberSmall": "object-light-props-module__i6SK7W__inputNumberSmall",
  "inputRow": "object-light-props-module__i6SK7W__inputRow",
  "inputRowSmall": "object-light-props-module__i6SK7W__inputRowSmall",
  "shadowCameraContent": "object-light-props-module__i6SK7W__shadowCameraContent",
  "shadowContent": "object-light-props-module__i6SK7W__shadowContent",
  "shadowSection": "object-light-props-module__i6SK7W__shadowSection",
});
